"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDeviceControlTranasaction = exports.DeviceControlTransaction = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const millisecondOperations_1 = require("../../util/time/millisecondOperations");
const commonAttributeTypes_1 = require("../commonAttributeSets/commonAttributeTypes");
const ModelCommon_1 = require("../ModelCommon");
const iotv_v3_types_2 = require("@iotv/iotv-v3-types");
const ModelClassInterfaces_1 = require("../../ModelClassInterfaces");
const className = 'DeviceControlTransaction';
// dpk: DeviceID ( the id not the eui )
// dsk: AWS_MessageId or in the case of TTNE/CS a correlationId
// deviceDlCnt: the downlink count incremented on the device record for this DCT, undefined before sending
class DeviceControlTransaction extends ModelCommon_1.ModelCommon {
    constructor({ ttl, devicePk, status, initialRequest, initialPayloadStr, requestInitiator, timestamp, transactionStages, broadcastScheduleSk, AWS_MessageId, sentPayloadStr, deviceDlCnt, ...others }) {
        super(className, { ...others });
        /* 2025 04 device attributes minimized for storage.
                this mimimal device can be used for system operation and retrieval.
                do not use as a proxy for the latest device data.
            */
        const { device } = initialRequest;
        initialRequest.device = (0, ModelClassInterfaces_1.getMinimalValidDeviceObject)(device) ?? device;
        this.ttl = ttl;
        this.pk = devicePk ?? others.pk;
        this.devicePk = devicePk;
        this.status = status;
        this.initialRequest = initialRequest;
        this.initialPayloadStr = initialPayloadStr;
        this.requestInitiator = requestInitiator;
        this.timestamp = timestamp;
        this.transactionStages = transactionStages ?? [];
        this.broadcastScheduleSk = broadcastScheduleSk;
        this.AWS_MessageId = AWS_MessageId;
        this.deviceDlCnt = deviceDlCnt;
        this.sentPayloadStr = sentPayloadStr;
        this.ttl = (0, millisecondOperations_1.getTTLSeconds)(1);
    }
    getUserAttributes() {
        const atts = {
            ...super.getUserAttributes(),
            status: {
                type: 'Enum',
                label: 'Status',
                editable: false,
                enumKv: iotv_v3_types_2.DeviceTransactionStatus,
            },
            initiator: {
                type: 'String',
                label: 'Initiator',
                editable: false,
                valueFn: () => this.requestInitiator?.name,
            },
            initialRequest: {
                type: 'object',
                label: 'Request',
                editable: false,
            },
            timestamp: { ...(0, commonAttributeTypes_1.getDateUserAttribute)('timestamp', 'Timestamp'), type: 'Date', editable: false },
            transactionStages: { type: 'object', label: 'Stages', editable: false },
        };
        return atts;
    }
}
exports.DeviceControlTransaction = DeviceControlTransaction;
const DeviceControlTranasactionMatcher = {
    initialRequest: undefined,
    pk: undefined,
    requestInitiator: undefined,
    status: undefined,
    timestamp: undefined,
    transactionStages: undefined,
    ttl: undefined,
    type: 'DeviceControlTransaction',
};
const isDeviceControlTranasaction = (object) => {
    const c = object;
    return (0, iotv_v3_types_1.matchObjectKeys)(DeviceControlTranasactionMatcher, c) && (0, iotv_v3_types_1.isVOBofType)('Device', c.initialRequest.device);
};
exports.isDeviceControlTranasaction = isDeviceControlTranasaction;
